import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const ArrowDownXS = createSvgIcon(
  <path d="M1 2.04 2.048 1 6 4.92 9.952 1 11 2.04 6 7 1 2.04Z" />,
  'ArrowDownXS'
);

export { ArrowDownXS };